import Card from "react-bootstrap/Card";
import useStore from "../../../../Zustand/Zustand";
import ZustandFormImovel from "../../../../Zustand/ZustandFormImovel";
import ZustandProductCgi from "../../../../Zustand/ZustandProductCgi";
import formatToReal from "../../../../Utils/fomartToReal";
import ListGroup from "react-bootstrap/ListGroup";
import { Col } from "react-bootstrap";

const TitleNameCard = ({ name }) => (
  <Col
    style={{
      fontFamily: "Inter",
      fontSize: "12px",
      fontWeight: "400",
      color: "#7F7F7F",
    }}
  >
    {name}
  </Col>
);

const MensageCard = ({ msg }) => (
  <Col
    style={{
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: "400",
      color: "rgba(0, 0, 0, 0.80)",
    }}
  >
    {msg}
  </Col>
);

const SimulationInterMobile = () => {
  const { valorDeEntrada, valorDoImovel, prazoMeses, valorFGTS} = ZustandFormImovel();
  const { cgi, prazoMesesCgi, valorEmprestimo } = ZustandProductCgi();

  const simulacoes = useStore((state) => state.simulacoes);
  const valorFinanciamento = valorDoImovel - valorDeEntrada;
  return (
    <>
      {simulacoes.map((simulacao, index) => (
        <div
          key={index}
          className="d-flex justify-content-center align-items-center text-center"
        >
          <Card style={{ width: "18rem" }} className="mx-auto">
            <ListGroup variant="flush">
              <ListGroup.Item className="text-center">
                <img
                  src="./assets/inter.svg"
                  alt="Logo Icon"
                  style={{ width: "auto", height: "auto" }}
                />
              </ListGroup.Item>
              {cgi != "CGI" ? (
                <ListGroup.Item className="text-center">
                  <TitleNameCard name="Valor do financiamento" />
                  <MensageCard msg={formatToReal(valorFinanciamento)} />
                </ListGroup.Item>
              ) : (
                <ListGroup.Item className="text-center">
                  <TitleNameCard name="Valor do emprestimo" />
                  <MensageCard msg={formatToReal(valorEmprestimo)} />
                </ListGroup.Item>
              )}
              {cgi != "CGI" ? (
                <ListGroup.Item className="text-center">
                  <TitleNameCard name="Valor da entrada / FGTS" />
                  <MensageCard
                    msg={formatToReal(valorDeEntrada || 0 + valorFGTS || 0)}
                  />
                </ListGroup.Item>
              ) : null}

              {cgi != "CGI" ? (
                <ListGroup.Item className="text-center">
                  <TitleNameCard name="Prazo" />
                  <MensageCard msg={prazoMeses} meses />
                </ListGroup.Item>
              ) : (
                <ListGroup.Item className="text-center">
                  <TitleNameCard name="Prazo" />
                  <MensageCard msg={prazoMesesCgi} meses />
                </ListGroup.Item>
              )}

              <ListGroup.Item className="text-center">
                <TitleNameCard name="Primeira parcela" />
                <MensageCard
                  msg={formatToReal(simulacao.valorPrimeiraParcela)}
                />
              </ListGroup.Item>

              <ListGroup.Item className="text-center">
                <TitleNameCard name="Última parcela" />
                <MensageCard msg={formatToReal(simulacao.valorUltimaParcela)} />
              </ListGroup.Item>

              <ListGroup.Item className="text-center">
                <TitleNameCard name="Sistema de Amortização" />
                <MensageCard msg={simulacao.sistemaAmortizacao} />
              </ListGroup.Item>
              <ListGroup.Item className="text-center">
                <TitleNameCard name="Taxa de juros" />
                <MensageCard msg={simulacao.produto} />
              </ListGroup.Item>
            </ListGroup>
          </Card>
        </div>
      ))}
    </>
  );
};

export default SimulationInterMobile;
